import * as React from "react";
import { useIsoLayoutEffect } from "../../utils/useIsoLayoutEffect.js";
import { useStableCallback } from "../../utils/useStableCallback.js";
function useValueChanged(value, onChange) {
  const valueRef = React.useRef(value);
  const onChangeCallback = useStableCallback(onChange);
  useIsoLayoutEffect(() => {
    if (valueRef.current !== value) {
      onChangeCallback(valueRef.current);
    }
    valueRef.current = value;
  }, [value, onChangeCallback]);
}
export {
  useValueChanged
};
//# sourceMappingURL=useValueChanged.js.map
